import React from "react";
import { Phone } from "lucide-react";

const LOGO_URL = "/images/logo.png";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative pt-16 pb-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid sm:grid-cols-2 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={LOGO_URL}
                alt="DIGIFRIEND"
                className="w-12 h-12 rounded-xl ring-1 ring-purple-500/30"
              />
              <div>
                <div className="font-display font-extrabold text-xl">
                  DIGI<span className="text-[#9B5BFF]">FRIEND</span>
                </div>
                <div className="text-[11px] tracking-[0.18em] uppercase text-white/40">
                  Digital Premium
                </div>
              </div>
            </div>
            <p className="mt-5 text-white/55 text-sm leading-relaxed max-w-md">
              Melayani Segala Kebutuhan Digital Anda. Capcut Premium, Game Repack
              aman, dan E-Book bermanfaat dengan harga terjangkau.
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.18em] text-white/85">
              Navigasi
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-white/60">
              {[
                ["Beranda", "#hero"],
                ["Tentang", "#tentang"],
                ["Katalog", "#katalog"],
                ["Testimoni", "#testimoni"],
              ].map(([l, h]) => (
                <li key={h}>
                  <a
                    data-testid={`footer-link-${h.replace("#", "")}`}
                    href={h}
                    className="hover:text-white transition"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="font-display font-semibold text-sm uppercase tracking-[0.18em] text-white/85">
              Kontak Admin
            </h4>
            <a
              data-testid="footer-phone-link"
              href="https://wa.me/62882003976301"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-3 group"
            >
              <span className="w-10 h-10 rounded-full bg-[#7B2DFF]/20 border border-[#7B2DFF]/30 flex items-center justify-center text-[#cdb6ff] group-hover:bg-[#7B2DFF]/30 transition">
                <Phone size={16} />
              </span>
              <span className="font-display font-semibold text-base text-white/90 group-hover:text-white transition">
                0882-0039-76301
              </span>
            </a>
            <p className="text-white/45 text-xs mt-3">Online setiap hari · 24 jam</p>
          </div>
        </div>

        <div className="div-line my-10" />

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-white/45">
          <div>
            <span className="text-white/70 font-medium">DIGIFRIEND © 2026</span>{" "}
            · Melayani Segala Kebutuhan Digital Anda
          </div>
          <div className="tracking-[0.16em] uppercase">
            Built with passion for premium digital experiences
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
